<div class="guide-section">
  <div class="row">
    <div class="guide-section__title" style="padding-top: 40px">
      Preferred delivery service
      <div class="guide-section__subtext">Select the carrier to use for this method</div>
    </div>
    <div class="content__recommended-delivery">
      <div class="content__recommended-delivery__title">Preferred delivery service</div>
      <form [formGroup]="formGroup">
        <div class="row" [ngStyle]="{ 'margin': '16px 0', display: 'block' }">
          <div [ngStyle]="{ display: 'flex', gap: '8px', 'align-items': 'baseline' }">
            <pdq-dropdown
              [fullWidth]="true"
              [options]="carrierOptions$ | async"
              [defaultOption]="defaultCarrierOption"
              placeholder="Select your carrier"
              title="Choose delivery service"
              (onChange)="onCarrierSelected($event)"
              [invalid]="!formGroup.get('carrierId').valid">
            </pdq-dropdown>
            <pdq-input-arrows
              *pdqHiddenInGlobaleMode
              (wheel)="$event.preventDefault()"
              (scroll)="$event.preventDefault()"
              min="0"
              widthSize="auto"
              formControlName="SLABDays"
              label="Filter maximal transit time"
              [required]="false"
              placeholder="Maximal transit {{ shippingMethodCategory === 'local' ? 'hours' : 'days' }}"></pdq-input-arrows>
            @if (shop?.metadata?.activateFilterShippingMethodsByLatestArrivalDate &&
            DOMESTIC_LIVE_RATES_METHOD_TYPES.includes(shippingMethodCategory)) {
            <pdq-date-input
              [tooltip]="'Calculated using processing days setup below. Shipments with ETA of the date input will be displayed'"
              class="filter_latest_arrival_date"
              height="36px"
              [control]="this.formGroup?.get('latestArrivalDateToFilter')"
              [invalidMsg]="'Valid format is MM/DD/YYYY'"
              [invalid]="this.formGroup?.get('latestArrivalDateToFilter')?.invalid"
              label="Filter by latest arrival date"></pdq-date-input>
            }
          </div>
        </div>
      </form>

      <form [formGroup]="shipmentExtrasFormGroup">
        @if (activeCarrier?.providers?.length) { @for (provider of activeCarrier.providers; track provider; let i =
        $index) {
        <div>
          <div class="carrier-provider-section">
            <div class="carrier-provider-section__providers" [ngStyle]="{ opacity: !provider.enabled ? '0.5' : '1' }">
              <!-- provider left arrow -->
              @if (provider.providerServices?.length && (shippingMethodCategory === 'domestic_live_rate' ||
              shippingMethodCategory === 'international_live_rate' || shippingMethodCategory === 'domestic_fixed_rate'
              || shippingMethodCategory === 'international_fixed_rate')) {
              <div class="arrow-icon" (click)="onArrowClick($event, i)">
                <img
                  class="arrow-icon__img"
                  [ngClass]="{ open: arrowFunctionArray && arrowFunctionArray[i] }"
                  src="assets/icons/chevron_down.svg"
                  alt="" />
              </div>
              }
              <!-- provider logo -->
              <carrier-logo [carrierName]="provider.name?.toLowerCase()?.replace(' ', '')" size="small"></carrier-logo>
              <!-- provider name -->
              <div class="carrier-provider-section__title">
                {{ getProviderDisplayNameMap(provider) || provider.name }}
              </div>
              <!-- provider toggle -->
              <pdq-slide-toggle
                (onToggle)="onProviderSelect($event, provider)"
                [defaultValue]="selectedActiveProviders?.includes(provider?.name?.toLowerCase())"
                [disabled]="!provider.enabled">
              </pdq-slide-toggle>
            </div>
            <!-- provider services -->
            @if (arrowFunctionArray && arrowFunctionArray[i]) {
            <div class="carrier-provider-section__service-levels">
              @if (shippingMethodCategory === 'domestic_live_rate' || shippingMethodCategory ===
              'international_live_rate' || shippingMethodCategory === 'domestic_fixed_rate' || shippingMethodCategory
              === 'international_fixed_rate') { @for ( providerService of provider.providerServices; track
              providerService; let j = $index) {
              <div class="checkbox-control">
                <pdq-checkbox
                  [ngStyle]="{ opacity: !provider.enabled || !providerService.enabled ? '0.5' : '1' }"
                  [checked]="activeProviderServicesIds.includes(providerService.id?.toString())"
                  (onChange)="onProviderServiceSelect($event, providerService)"
                  [disabled]="!provider.enabled || !providerService.enabled"
                  label="{{ providerService['displayName'] }}">
                </pdq-checkbox>
              </div>
              } }
            </div>
            }
          </div>
        </div>
        } } @if (shipmentExtrasFields?.length) {
        <div class="advanced-settings" (click)="isAdvancedSettingsDisplayed = !isAdvancedSettingsDisplayed">
          Advanced settings
          <img
            class="advanced-settings__trend"
            src="assets/icons/triangle.svg"
            [ngClass]="{ up: isAdvancedSettingsDisplayed, down: !isAdvancedSettingsDisplayed }"
            alt="" />
        </div>
        @if (isAdvancedSettingsDisplayed) {
        <div class="default-delivery-service__subtitle">Enable shipment extras</div>
        @for (shipmentFields of shipmentExtrasFields; track shipmentFields) {
        <div>
          @if (shipmentFields.type == fieldsTypes.CHECKBOX) {
          <div>
            <pdq-checkbox
              labelSize="small"
              [label]="shipmentFields.displayName"
              [icon]="shipmentFields.infoIcon ? 'more_information' : null"
              [description]="shipmentFields.description ? shipmentFields.description : ''"
              formControlName="{{ shipmentFields.fieldName }}">
            </pdq-checkbox>
          </div>
          }
          <div
            class="input-arrows"
            [ngClass]="{
                  dryIceWeightUnit: shipmentFields.fieldName === 'dryIceWeightUnit',
                  insuranceAmountType: shipmentFields.fieldName === 'insuranceAmountType'
                }">
            @if (shipmentFields.type == fieldsTypes.NUMBER) {
            <pdq-input-arrows
              placeholder="{{ shipmentFields.placeHolder }}"
              [precision]="shipmentFields.numberType === 'double' ? 1 : 0"
              formControlName="{{ shipmentFields.fieldName }}"
              type="number"
              [disabled]="!shipmentExtrasFormGroup.controls[shipmentFields.requiredFieldName].value">
            </pdq-input-arrows>
            } @if (shipmentFields.type == fieldsTypes.SELECT) {
            <pdq-dropdown
              [options]="shipmentFields.options"
              placeholder="{{ shipmentFields.placeHolder }}"
              formControlName="{{ shipmentFields.fieldName }}"
              [defaultOption]="
                                    findDefaultOption(
                                      shipmentFields.options,
                                      shipmentExtrasFormGroup.controls[shipmentFields.fieldName]
                                    )
                                  "
              [disabled]="!shipmentExtrasFormGroup.controls[shipmentFields.requiredFieldName].value">
            </pdq-dropdown>
            }
          </div>
        </div>
        } } }
      </form>
    </div>
  </div>
</div>
